import ActivityIcon from "@skystake/asset/icons/activity.svg?react";
import AddCategoryFillIcon from "@skystake/asset/icons/add-category-fill.svg?react";
import AddCircleIcon from "@skystake/asset/icons/add-circle.svg?react";
import AddIcon from "@skystake/asset/icons/add.svg?react";
import AnonymousIcon from "@skystake/asset/icons/anonymous.svg?react";
import AwardIcon from "@skystake/asset/icons/award.svg?react";
import BadmintonIcon from "@skystake/asset/icons/badminton.svg?react";
import BalanceTwoIcon from "@skystake/asset/icons/balance-two.svg?react";
import BaseballIcon from "@skystake/asset/icons/baseball.svg?react";
import BasketBallIcon from "@skystake/asset/icons/basketball.svg?react";
import BatteryIcon from "@skystake/asset/icons/battery.svg?react";
import BlackJackIcon from "@skystake/asset/icons/blackjack.svg?react";
import BowlingIcon from "@skystake/asset/icons/bowling.svg?react";
import BoxingIcon from "@skystake/asset/icons/boxing.svg?react";
import BrainIcon from "@skystake/asset/icons/brain.svg?react";
import BtcIcon from "@skystake/asset/icons/btc.svg?react";
import CalendarIcon from "@skystake/asset/icons/calendar.svg?react";
import CardFillIcon from "@skystake/asset/icons/card-fill.svg?react";
import CardIcon from "@skystake/asset/icons/card.svg?react";
import CasinoIcon from "@skystake/asset/icons/casino.svg?react";
import ChartIcon from "@skystake/asset/icons/chart.svg?react";
import CheckIcon from "@skystake/asset/icons/check.svg?react";
import CherryIcon from "@skystake/asset/icons/cherry.svg?react";
import CloseSquareIcon from "@skystake/asset/icons/close-square.svg?react";
import CloseIcon from "@skystake/asset/icons/close.svg?react";
import ConfettiIcon from "@skystake/asset/icons/confetti.svg?react";
import CopyIcon from "@skystake/asset/icons/copy.svg?react";
import Dice2Icon from "@skystake/asset/icons/dice2.svg?react";
import DiceIcon from "@skystake/asset/icons/dice.svg?react";
import Document2Icon from "@skystake/asset/icons/document2.svg?react";
import DocumentAlignRight2Icon from "@skystake/asset/icons/document-align-right-2.svg?react";
import DocumentAlignIcon from "@skystake/asset/icons/document-align.svg?react";
import DocumentDownloadIcon from "@skystake/asset/icons/document-download.svg?react";
import DocumentIcon from "@skystake/asset/icons/document.svg?react";
import DollarFillIcon from "@skystake/asset/icons/dollar-fill.svg?react";
import DollarSquareIcon from "@skystake/asset/icons/dollar-square.svg?react";
import DotIcon from "@skystake/asset/icons/dot.svg?react";
import DownSquareIcon from "@skystake/asset/icons/down-square.svg?react";
import DownIcon from "@skystake/asset/icons/down.svg?react";
import DownloadIcon from "@skystake/asset/icons/download.svg?react";
import EditFillIcon from "@skystake/asset/icons/edit-fill.svg?react";
import EditSquareIcon from "@skystake/asset/icons/edit-square.svg?react";
import EthIcon from "@skystake/asset/icons/eth.svg?react";
import Eye2Icon from "@skystake/asset/icons/eye2.svg?react";
import EyeClosedIcon from "@skystake/asset/icons/eye-closed.svg?react";
import EyeIcon from "@skystake/asset/icons/eye.svg?react";
import FaqCircleIcon from "@skystake/asset/icons/faq-circle.svg?react";
import FootballIcon from "@skystake/asset/icons/football.svg?react";
import ForeignIcon from "@skystake/asset/icons/foreign.svg?react";
import ForgotPasswordIcon from "@skystake/asset/icons/forgot-password.svg?react";
import FullIcon from "@skystake/asset/icons/full.svg?react";
import GamblingFillIcon from "@skystake/asset/icons/gambling-fill.svg?react";
import GamblingIcon from "@skystake/asset/icons/gambling.svg?react";
import GamePadIcon from "@skystake/asset/icons/gamepad.svg?react";
import GiftIcon from "@skystake/asset/icons/gift.svg?react";
import HeadphoneIcon from "@skystake/asset/icons/headphone.svg?react";
import HockeyIcon from "@skystake/asset/icons/hockey.svg?react";
import InformationSquareIcon from "@skystake/asset/icons/information-square.svg?react";
import InformationIcon from "@skystake/asset/icons/information.svg?react";
import InternationalIcon from "@skystake/asset/icons/international.svg?react";
import LeftIcon from "@skystake/asset/icons/left.svg?react";
import LikeIcon from "@skystake/asset/icons/like.svg?react";
import LinkIcon from "@skystake/asset/icons/link.svg?react";
import LiveIcon from "@skystake/asset/icons/live.svg?react";
import LobbyIcon from "@skystake/asset/icons/lobby.svg?react";
import LockIcon from "@skystake/asset/icons/lock.svg?react";
import LogoutIcon from "@skystake/asset/icons/logout.svg?react";
import LtcIcon from "@skystake/asset/icons/ltc.svg?react";
import Menu2Icon from "@skystake/asset/icons/menu2.svg?react";
import MenuFillIcon from "@skystake/asset/icons/menu-fill.svg?react";
import MenuIcon from "@skystake/asset/icons/menu.svg?react";
import Message2Icon from "@skystake/asset/icons/message2.svg?react";
import Message3Icon from "@skystake/asset/icons/message3.svg?react";
import MessageIcon from "@skystake/asset/icons/message.svg?react";
import MoonIcon from "@skystake/asset/icons/moon.svg?react";
import MoreSquareIcon from "@skystake/asset/icons/more-square.svg?react";
import MouseIcon from "@skystake/asset/icons/mouse.svg?react";
import Multi2Icon from "@skystake/asset/icons/multi2.svg?react";
import MultiIcon from "@skystake/asset/icons/multi.svg?react";
import NotificationIcon from "@skystake/asset/icons/notification.svg?react";
import PaperClipIcon from "@skystake/asset/icons/paper-clip.svg?react";
import PinIcon from "@skystake/asset/icons/pin.svg?react";
import PlaySquareIcon from "@skystake/asset/icons/play-square.svg?react";
import PlayIcon from "@skystake/asset/icons/play.svg?react";
import ProfileAdd1Icon from "@skystake/asset/icons/profile-add1.svg?react";
import ProfileAdd2Icon from "@skystake/asset/icons/profile-add2.svg?react";
import ProfileCircleIcon from "@skystake/asset/icons/profile-circle.svg?react";
import ProfileSquareIcon from "@skystake/asset/icons/profile-square.svg?react";
import ProfileIcon from "@skystake/asset/icons/profile.svg?react";
import PromotionIcon from "@skystake/asset/icons/promotion.svg?react";
import Ps51Icon from "@skystake/asset/icons/ps51.svg?react";
import RectangleIcon from "@skystake/asset/icons/rectangle.svg?react";
import RefreshIcon from "@skystake/asset/icons/refresh.svg?react";
import ReportIcon from "@skystake/asset/icons/report.svg?react";
import Right2Icon from "@skystake/asset/icons/right2.svg?react";
import RightIcon from "@skystake/asset/icons/right.svg?react";
import RocketIcon from "@skystake/asset/icons/rocket.svg?react";
import ScanIcon from "@skystake/asset/icons/scan.svg?react";
import SearchIcon from "@skystake/asset/icons/search.svg?react";
import SecurityFillIcon from "@skystake/asset/icons/security-fill.svg?react";
import SecurityIcon from "@skystake/asset/icons/security.svg?react";
import Send2Icon from "@skystake/asset/icons/send2.svg?react";
import Send3Icon from "@skystake/asset/icons/send3.svg?react";
import SendIcon from "@skystake/asset/icons/send.svg?react";
import SettingsIcon from "@skystake/asset/icons/settings.svg?react";
import ShieldTickIcon from "@skystake/asset/icons/shield-tick.svg?react";
import Single2Icon from "@skystake/asset/icons/single2.svg?react";
import SingleIcon from "@skystake/asset/icons/single.svg?react";
import SituationIcon from "@skystake/asset/icons/situation.svg?react";
import SoccerFillIcon from "@skystake/asset/icons/soccer-fill.svg?react";
import SoccerIcon from "@skystake/asset/icons/soccer.svg?react";
import SportsIcon from "@skystake/asset/icons/sports.svg?react";
import Star2Icon from "@skystake/asset/icons/star2.svg?react";
import Star3Icon from "@skystake/asset/icons/star3.svg?react";
import StarIcon from "@skystake/asset/icons/star.svg?react";
import SunIcon from "@skystake/asset/icons/sun.svg?react";
import SwapIcon from "@skystake/asset/icons/swap.svg?react";
import TableTennisIcon from "@skystake/asset/icons/table-tennis.svg?react";
import TennisIcon from "@skystake/asset/icons/tennis.svg?react";
import TickSquareIcon from "@skystake/asset/icons/tick-square.svg?react";
import TimeCircleIcon from "@skystake/asset/icons/time-circle.svg?react";
import TrashIcon from "@skystake/asset/icons/trash.svg?react";
import UploadIcon from "@skystake/asset/icons/upload.svg?react";
import UpSquareIcon from "@skystake/asset/icons/upsquare.svg?react";
import UsdcIcon from "@skystake/asset/icons/usdc.svg?react";
import UsdtIcon from "@skystake/asset/icons/usdt.svg?react";
import UserGroupIcon from "@skystake/asset/icons/user-group.svg?react";
import UserTagIcon from "@skystake/asset/icons/user-tag.svg?react";
import UserIcon from "@skystake/asset/icons/user.svg?react";
import VerifiedIcon from "@skystake/asset/icons/verified.svg?react";
import VolleyballIcon from "@skystake/asset/icons/volleyball.svg?react";
import WalletIcon from "@skystake/asset/icons/wallet.svg?react";
import WatchIcon from "@skystake/asset/icons/watch.svg?react";
import Website2Icon from "@skystake/asset/icons/website2.svg?react";
import WebsiteFillIcon from "@skystake/asset/icons/website-fill.svg?react";
import WebsiteIcon from "@skystake/asset/icons/website.svg?react";
import WiFiIcon from "@skystake/asset/icons/wifi.svg?react";
import XrpIcon from "@skystake/asset/icons/xrp.svg?react";
import { ComponentType, SVGProps } from "react";

export type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const ICONS_MAP = {
  activity: ActivityIcon,
  "add-category-fill": AddCategoryFillIcon,
  add: AddIcon,
  "add-circle": AddCircleIcon,
  anonymous: AnonymousIcon,
  award: AwardIcon,
  badminton: BadmintonIcon,
  "balance-two": BalanceTwoIcon,
  baseball: BaseballIcon,
  basketball: BasketBallIcon,
  battery: BatteryIcon,
  blackjack: BlackJackIcon,
  bowling: BowlingIcon,
  boxing: BoxingIcon,
  brain: BrainIcon,
  btc: BtcIcon,
  calendar: CalendarIcon,
  "card-fill": CardFillIcon,
  card: CardIcon,
  casino: CasinoIcon,
  chart: ChartIcon,
  check: CheckIcon,
  cherry: CherryIcon,
  close: CloseIcon,
  confetti: ConfettiIcon,
  copy: CopyIcon,
  "close-square": CloseSquareIcon,
  dice: DiceIcon,
  dice2: Dice2Icon,
  document: DocumentIcon,
  document2: Document2Icon,
  "down-square": DownSquareIcon,
  "document-align-right-2": DocumentAlignRight2Icon,
  "document-align": DocumentAlignIcon,
  "document-download": DocumentDownloadIcon,
  "dollar-fill": DollarFillIcon,
  "dollar-square": DollarSquareIcon,
  dot: DotIcon,
  down: DownIcon,
  download: DownloadIcon,
  "edit-fill": EditFillIcon,
  "edit-square": EditSquareIcon,
  eth: EthIcon,
  eye: EyeIcon,
  eye2: Eye2Icon,
  "eye-closed": EyeClosedIcon,
  "faq-circle": FaqCircleIcon,
  "american-football": FootballIcon,
  foreign: ForeignIcon,
  "forgot-password": ForgotPasswordIcon,
  full: FullIcon,
  gambling: GamblingIcon,
  "gambling-fill": GamblingFillIcon,
  gamepad: GamePadIcon,
  gift: GiftIcon,
  headphone: HeadphoneIcon,
  "ice-hockey": HockeyIcon,
  international: InternationalIcon,
  information: InformationIcon,
  "information-square": InformationSquareIcon,
  left: LeftIcon,
  like: LikeIcon,
  link: LinkIcon,
  live: LiveIcon,
  lobby: LobbyIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  ltc: LtcIcon,
  menu: MenuIcon,
  menu2: Menu2Icon,
  "menu-fill": MenuFillIcon,
  message: MessageIcon,
  message2: Message2Icon,
  message3: Message3Icon,
  moon: MoonIcon,
  "more-square": MoreSquareIcon,
  mouse: MouseIcon,
  "e-sports": MouseIcon,
  notification: NotificationIcon,
  "paper-clip": PaperClipIcon,
  pin: PinIcon,
  "play-square": PlaySquareIcon,
  play: PlayIcon,
  profile: ProfileIcon,
  "profile-add1": ProfileAdd1Icon,
  "profile-add2": ProfileAdd2Icon,
  "profile-circle": ProfileCircleIcon,
  "profile-square": ProfileSquareIcon,
  promotion: PromotionIcon,
  ps51: Ps51Icon,
  rectangle: RectangleIcon,
  refresh: RefreshIcon,
  report: ReportIcon,
  right: RightIcon,
  right2: Right2Icon,
  rocket: RocketIcon,
  scan: ScanIcon,
  search: SearchIcon,
  security: SecurityIcon,
  "security-fill": SecurityFillIcon,
  send: SendIcon,
  send2: Send2Icon,
  send3: Send3Icon,
  settings: SettingsIcon,
  "shield-tick": ShieldTickIcon,
  situation: SituationIcon,
  soccer: SoccerIcon,
  "soccer-fill": SoccerFillIcon,
  sports: SportsIcon,
  star: StarIcon,
  star2: Star2Icon,
  star3: Star3Icon,
  sun: SunIcon,
  swap: SwapIcon,
  "table-tennis": TableTennisIcon,
  tennis: TennisIcon,
  "tick-square": TickSquareIcon,
  "time-circle": TimeCircleIcon,
  trash: TrashIcon,
  upload: UploadIcon,
  upsquare: UpSquareIcon,
  usdc: UsdcIcon,
  usdt: UsdtIcon,
  user: UserIcon,
  "user-group": UserGroupIcon,
  "user-tag": UserTagIcon,
  verified: VerifiedIcon,
  volleyball: VolleyballIcon,
  wallet: WalletIcon,
  watch: WatchIcon,
  "website-fill": WebsiteFillIcon,
  website: WebsiteIcon,
  website2: Website2Icon,
  wifi: WiFiIcon,
  xrp: XrpIcon,
  single: SingleIcon,
  single2: Single2Icon,
  multi: MultiIcon,
  multi2: Multi2Icon,
} satisfies Record<string, SvgIconComponent>;
